import React, { useEffect, useState } from "react";
import NewSimulationButton from "./new-simulation-button";
import Disclaimer from "./disclaimer";
// @ts-ignore
import { Link } from 'react-router-dom';
import consts, { SCR_APP_URLS } from "shared/consts";
import { getLibraryURL } from "src/utils/get-simulation-library-url";
import store from "src/store";
import useHistory from "src/use-history";
import useIsLoggedIn from "src/utils/use-is-logged-in";

function qs() {
    return require('qs').parse(location.search.slice(1))
}

export default function DiscoverSimulationHeader(props) {
    const { userInfo } = useIsLoggedIn();
    const history = useHistory();
    const [isCiReview, setIsCiReview] = useState(false);
    const [parentReviewId, setParentReviewId] = useState('');
    const [ciReviewId, setCiReviewId] = useState('');

    const redirectToLogin = () => {
        location.href = window['config'].AUTH_UI;
    }

    useEffect(() => {
        checkAndSetReadOnly();
    }, [props.isLoggedIn, qs().review_id]);

    const checkAndSetReadOnly = () => {
        // reseting before check
        setIsCiReview(false);
        setParentReviewId('');
        setCiReviewId('');

        if (!props.isLoggedIn) {  //checking if user not logged in or guest user then make readonly true
            store.isReadOnly = true;
        } else if (props.isLoggedIn && !qs().review_id) { //checking if user not logged in or guest user but no review simulation then make readonly false
            store.isReadOnly = false;
        } else if (props.isLoggedIn && qs().review_id) {
            checkIfCiReview();
        } else {
            store.isReadOnly = false;
        }
        store.updateStore();
    }

    const checkIfCiReview = async () => {
        try {
            let reviewData = await store.fetchOneReview(qs().review_id);

            if (reviewData['parentReviewID']) { //checking if it is a ci review then make readonly true
                setIsCiReview(true);
                setParentReviewId(reviewData['parentReviewID']);
                store.isReadOnly = true;
            }
            else if (reviewData.user != props.isLoggedIn?.email) { //checking if the review is not owened by logged in user then make readonly true
                setIsCiReview(false);
                store.isReadOnly = true;
            }
            else {
                setIsCiReview(false);
                store.isReadOnly = false;
            }
            setCiReviewId(reviewData['_id']);
        } catch (err) {
            console.log('Some error has occured while checking is Ci review ', err);
        } finally {
            store.updateStore();
        }
    }

    const getDiscoverSimulationsHeader = () => {
        if (qs().review_id && store.selectedReviewData['name']) {
            return (
                <>
                    {
                        !userInfo?.auth0Subscripton &&
                        <>
                            <span css="cursor: pointer;"
                                onClick={() => {
                                    store.setEngagementManagerFilterLocalStorage({ orgId: store.selectedReviewData['organizationData']?.['_id'] });
                                    history.push(SCR_APP_URLS.engagementManager);
                                }}>{store.selectedReviewData['organizationData']?.['name']}</span>&nbsp;/&nbsp;
                        </>
                    }

                    <span css="cursor: pointer;"
                        onClick={() => {
                            store.setMyReviewFilterLocalStorage({ engagementId: store.selectedReviewData['engagementData']?.['engId'] });
                            history.push(SCR_APP_URLS.myReview);
                        }}
                    >{store.selectedReviewData['engagementData']['engId']}</span>&nbsp;/&nbsp;
                </>
            )
        } else {
            return null;
        }
    }

    return (
        <div>
            <div css={`
                display: flex;
                flex-direction: row;
                align-items: center;
            `}>
                <div css={`
                    width: 80%;
                `}>
                    <small css={`
                        color: #949494;
                    `}>{getDiscoverSimulationsHeader()}</small>
                    <div css={`
                        font-size:24px;
                        color:#2E2E38;
                    `}>
                        {qs().review_id ? `${(store.selectedReviewData?.name) ? store.selectedReviewData.name : ''} simulations` : "Public simulations"}
                    </div>
                    <div css={`
                        font-size:16px;
                        color:#2E2E38;
                        margin-top:12px;
                        `}>
                        {!props.isLoggedIn ? <span>
                            <span css={`
                                    color:#799fd4;
                                    cursor: pointer;
                                    text-decoration-line: underline;
                                `}
                                onClick={() => { redirectToLogin() }}
                            >
                                Create a free account
                            </span> to get started.</span> : null}
                        {
                            (props.isLoggedIn && !isCiReview && (parentReviewId || ciReviewId)) ?
                                <Link to={consts.SCR_APP_URLS.ciReview + '/' + ciReviewId}>Go to ci reviews</Link> : null
                        }
                    </div>
                </div>
                <div css={`
                        width: 20%;
                    `}>
                    <div css={`
                            float: right;
                        `}>
                        {
                            isCiReview ?
                                <Link to={getLibraryURL({
                                    engagement_id: qs().engagement_id.toString(),
                                    review_id: parentReviewId
                                })}>Go to parent review simulations</Link>
                                :
                                <NewSimulationButton isLoggedIn={props.isLoggedIn} />
                        }

                    </div>
                </div>
            </div>
            <Disclaimer />
        </div>
    )
}
